import React, {useState} from 'react';
import {Col, Container, Row} from "react-bootstrap";
import Assessment from "../../images/services/cto/Needs-Assessment.webp";
import Strategy from "../../images/services/cto/Strategy-Roadmap.webp";
import Testing from "../../images/services/cto/Implementation-Testing.webp";
import {LazyLoadImage} from "react-lazy-load-image-component";

function Technologysec(props) {
    const [activeTab, setActiveTab] = useState(1);

    function displayTab(tabNumber) {
        setActiveTab(tabNumber);
    }

    return (
        <>
            <div className="tekgriping_section p-100">
                <Container className="h-100">
                    <Row className="h-100">
                        <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto">
                            <div className="example" data-text="Our Forte">
                                <h2>CTO Consulting Process</h2>
                            </div>
                            <p>Transforming the decision-making process. As experts in technology and its application,
                                CTO consultants can provide valuable insights and advice on the most effective ways to
                                leverage technology to achieve a company's goals.</p>
                        </Col>
                        <Col xs={12} md={6} lg={7} xl={7} xxl={7}>
                            <div className="tekgrip_flex">
                                <div className="tekgrip_title">
                                    <h5>274B
                                        <span>Approx. market size</span></h5>
                                </div>
                                <div className="tekgrip_title">
                                    <h5>2.5M
                                        <span>Daily data production</span></h5>
                                </div>
                            </div>
                        </Col>
                        <Col xs={12} md={6} lg={7} xl={7} xxl={7}>
                            <h3 onClick={() => {
                                displayTab(1)
                            }} className={`tabs ${activeTab === 1 ? 'active' : ''}`}>
                                <div className="tab_namee">Needs Assessment</div>
                            </h3>

                            <h3 onClick={() => {
                                displayTab(2)
                            }} className={`tabs ${activeTab === 2 ? 'active' : ''}`}>
                                <div className="tab_namee">Strategy and Roadmap</div>
                            </h3>

                            <h3 onClick={() => {
                                displayTab(3)
                            }} className={`tabs ${activeTab === 3 ? 'active' : ''}`}>
                                <div className="tab_namee">Implementation and Testing</div>
                            </h3>
                        </Col>
                    </Row>
                </Container>
            </div>
            <div className="tekgrip_tabs_iamge tekrevol_dark_bg p-100">
                <Container className="h-100">
                    <Row className={activeTab === 1 ? 'd-flex h-100' : 'd-none h-100'}>
                        <Col xs={12} md={7} lg={6} xl={6} xxl={6} className="my-auto">
                            <div className="tekgrip_tabs_content">
                                <h2>Needs Assessment</h2>
                                <p>Every technology venture starts with a thorough needs assessment, whether for a
                                    product, service, or for expansion. Our CTO consulting helps clients identify their
                                    business objectives and goals, and long-term vision for business growth. The purpose
                                    of technology assessment is to identify areas of improvement and optimization that
                                    can help the company achieve its business goals more effectively and
                                    efficiently.</p>
                            </div>
                        </Col>
                        <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
                            <div className="tekgrip_tabs_image ">
                                <LazyLoadImage
                                    src={Assessment}
                                    effect="blur" alt="Assessment" className="img-fluid slide-top"
                                />
                            </div>
                        </Col>
                    </Row>
                    <Row className={activeTab === 2 ? 'd-flex h-100' : 'd-none h-100'}>
                        <Col xs={12} md={7} lg={6} xl={6} xxl={6} className="my-auto">
                            <div className="tekgrip_tabs_content">
                                <h2>Strategy & Roadmap</h2>
                                <p>Our business analysts and tech executives translate a client’s vision into a workable
                                    strategy and action plan. The roadmap may include recommendations for technology
                                    investments, process improvements, and system optimizations. Moreover, this action
                                    guides the further stages of product and solution design and development.</p>
                            </div>
                        </Col>
                        <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
                            <div className="tekgrip_tabs_image ">
                                <LazyLoadImage
                                    src={Strategy}
                                    effect="blur" alt="Strategy" className="img-fluid slide-top"
                                />
                            </div>
                        </Col>
                    </Row>
                    <Row className={activeTab === 3 ? 'd-flex h-100' : 'd-none h-100'}>
                        <Col xs={12} md={7} lg={6} xl={6} xxl={6} className="my-auto">
                            <div className="tekgrip_tabs_content">
                                <h2>Implementation & Testing</h2>
                                <p>Once the action roadmap is ready, a business alongside the CTO can start implementing
                                    the recommendations, building priority solutions, and testing the architecture
                                    necessary to sustain the technical changes. The CTO consultant can provide guidance
                                    and oversight throughout the implementation process to ensure that the technology
                                    solutions are deployed effectively and efficiently. After the implementation, the
                                    CTO consultant can also help with testing and quality assurance to ensure that the
                                    new systems and processes are working as intended..</p>
                            </div>
                        </Col>
                        <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
                            <div className="tekgrip_tabs_image ">
                                <LazyLoadImage
                                    src={Testing}
                                    effect="blur" alt="Testing" className="img-fluid slide-top"
                                />
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        </>
    );
}

export default Technologysec;